import type { Preset } from "@primeng/themes/types";

const GELDesignTokensBaseOverride = {
    semantic: {
        focusRing: {
            width: '2px'
        },
        colorScheme: {
            light: {
                content: {
                    hoverColor: '{slate.800}'
                }
            }
        }
    }
}

export const GELDesignTokensOverride = {
    ...GELDesignTokensBaseOverride,
    components: {
        button: {
            root: {
                paddingX: '0.75rem'
            }
        },
        datatable: {
            headerCell: {
                selectedBackground: '{emerald.50}',
                selectedColor: '{emerald.700}',
            }
        },
        tag: {
            root: {
                borderRadius: '{border.radius.md}'
            }
        },
        paginator: {
            root: {
                borderRadius: '0'
            }
        },
        tabs: {
            tablist: {
                borderColor: 'transparent transparent {content.borderColor} transparent',
            },
            tab: {
                borderColor: 'transparent',
                activeBorderColor: 'transparent',
                hoverBorderColor: 'transparent',
                color: '{gray.600}',
            },
            activeBar: {
                height: '2px'
            }
        },
        breadcrumb: {
            separator: {
                color: '{gray.700}'
            },
            extend: {
                normal: {
                    item: {
                        textDecoration: 'underline'
                    }
                },
                last: {
                    item: {
                        color: '{gray.600}',
                        textDecoration: 'none'
                    }
                }
            }
        },
        dialog: {
            header: {
                padding: '1.25rem'
            }
        },
        togglebutton: {
            root: {
                checkedBorderColor: '{brand.800}'
            }
        },
        select: {
            root: {
                placeholderColor: '{form.field.color}'
            }
        },
    },
    extend: {
        brand: {
            800: '#0B72A2'
        },
        gray: {
            100: '#F1F5F9',
            800: '#36464E'
        },
        gold: {
            50: "#fff9f0",
            100: "#FFEBCC",
            200: "#F2DAA1",
            300: "#FFAD33",
            400: "#D27F04",
            500: "#A3680F",
            600: "#8A5D19",
            700: "#755201",
            800: "#5F3E0D",
            900: "#473301",
            950: "#422800"
        },
        font: {
            family: {
                code: 'Fira Code'
            },
            size: {
                xxl: '2rem'
            }
        },
        text: {
            codeRegular: {
                fontFamily: '{font.family.code}',
                fontWeight: '{font.weight.regular}',
                fontSize: '{font.size.medium}',
                lineHeight: '{font.lineHeight.medium}'
            },
            codeSemibold: {
                fontFamily: '{font.family.code}',
                fontWeight: '{font.weight.semibold}',
                fontSize: '{font.size.medium}',
                lineHeight: '{font.lineHeight.medium}'
            }
        },
        datatable: {
            root: {
                borderRadius: '0.5rem'
            }
        },
        sideNav: {
            focusRing: {
                offset: '-2px'
            },
            item: {
                gap: '0.5rem'
            }
        },
        topNav: {
            height: '3.25rem',
            paddingX: '1rem',
            sectionGap: '1.5rem',
            background: '#ffffff',
            borderColor: '#e0e6eb',
            logo: {
                width: '14rem',
                height: '2.5rem'
            },
            link: {
                gap: '0.75rem',
                color: '#3d4f5c',
                fontSize: '1rem',
                fontWeight: '400',
                paddingX: '0.75rem',
                paddingY: '1.75rem',
                activeColor: '#036bb5',
                activeFontWeight: '500',
                activeBorderColor: '#036bb5',
                activeBorderWidth: '3px',
                hoverColor: '#036bb5',
                focusRing: {
                    color: "{focus.ring.color}",
                    style: "{focus.ring.style}",
                    width: "{focus.ring.width}",
                    offset: "{focus.ring.offset}",
                    shadow: "{focus.ring.shadow}"
                }
            },
            utility: {
                gap: '0.5rem',
                paddingX: '0.25rem',
                paddingY: '1.75rem',
                iconColor: '#3d4f5c',
                iconSize: '1rem',
                hoverColor: '#036bb5',
                activeColor: '#036bb5',
                activeBorderColor: '#036bb5',
                activeBorderWidth: '3px',
                focusRing: {
                    color: '{focus.ring.color}',
                    style: '{focus.ring.style}',
                    width: '{focus.ring.width}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}'
                }
            }
        }
    },
} satisfies Preset
